import { fetchData, deleteData } from 'modules/Axios';
import { showToast } from 'modules/Notifications';

export const defaultState = {
  currentTab: 'EXPORTS',
  integrationCurrentPage: 0,
  integrations: [],
  sortBy: 'createdAt',
  sortDirection: 'DESC',
  stats: null,
  statsCsvLink: null,
  totalRecordsIntegrations: Number.MAX_SAFE_INTEGER,
};

export const RECEIVE_ADMINISTRATION_INTEGRATIONS = 'RECEIVE_ADMINISTRATION_INTEGRATIONS';
export const receiveIntegrations = (payload) => ({ type: RECEIVE_ADMINISTRATION_INTEGRATIONS, payload });

export const UPDATE_INTEGRATIONS_PAGE = 'UPDATE_INTEGRATIONS_PAGE';
export const updateIntegrationsPage = (page) => ({ type: UPDATE_INTEGRATIONS_PAGE, payload: page });

export const INTEGRATION_UPDATE_SORT = 'INTEGRATION_UPDATE_SORT';
export const updateSort = (sortBy, sortDirection) => ({ type: INTEGRATION_UPDATE_SORT, payload: { sortBy, sortDirection } });

export const updateSortInIntegrationsGrid = (sortBy, sortDirection) => {
  return async (dispatch) => {
    dispatch(resetRouteData());
    dispatch(updateSort(sortBy, sortDirection));
  };
};

export const TOGGLE_TAB = 'TOGGLE_TAB';
export const toggleTab = (payload) => ({ type: TOGGLE_TAB, payload });

export const RESET_ROUTE_DATA = 'RESET_ROUTE_DATA';
export const resetRouteData = () => ({ type: RESET_ROUTE_DATA });

export const getIntegrations = ({ size }) => {
  return async (dispatch, getState) => {
    const { brand } = getState().app;
    const { integrationCurrentPage, integrations, sortBy, sortDirection } = getState().administration;
    const URL = `brands/${brand.id}/integrations?size=${size}&page=${integrationCurrentPage}&sort=${sortBy},${sortDirection}`;
    try {
      const currentGetIntegrationsRequest = await dispatch(fetchData(URL));
      dispatch(updateIntegrationsPage(integrationCurrentPage + 1));
      return dispatch(receiveIntegrations({
        integrations: integrations.concat(currentGetIntegrationsRequest.content),
        totalRecordsIntegrations: currentGetIntegrationsRequest.totalElements ?? defaultState.totalRecordsIntegrations,
      }));
    } catch (e) {
      return dispatch(showToast({
        state: 'ERROR',
        title: 'Error',
        message: 'Issue retrieving integrations list. Please try again later',
        dismissible: true,
        dismissAfter: 1500,
      }));
    }
  };
};

export const removeIntegration = (integrationId) => {
  return async (dispatch, getState) => {
    const { brand } = getState().app;
    const URL = `brands/${brand.id}/integrations/${integrationId}`;
    try {
      await dispatch(deleteData(URL));
      dispatch(showToast({
        state: 'SUCCESS',
        title: 'Success',
        message: 'Integration Removed Successfully',
        dismissible: true,
        dismissAfter: 2000,
      }));
      await dispatch(resetRouteData());
    } catch (e) {
      dispatch(showToast({
        state: 'ERROR',
        title: 'Error',
        message: e.message,
        dismissible: true,
        dismissAfter: 1500,
      }));
    }
  };
};

export const RECEIVE_CSV_STATS_LINK = 'RECEIVE_CSV_STATS_LINK';
export const receiveCsvStatsLink = (link) => ({ type: RECEIVE_CSV_STATS_LINK, payload: link });

export const GET_CVS_STATS = 'GET_CSV_STATS';
export const getCsvLinkStats = (queryParam) => {
  return async (dispatch, getState) => {
    const { brand } = getState().app;
    const URL = `/brands/${brand.id}/audiences/stats/onboarded-by-destinations/download${queryParam}`;
    try {
      const data = await dispatch(fetchData(URL, {}, {}, false, 'text'));
      return data;
    } catch (e) {
      console.error('API Call to /audiences/stats/onboarded-by-destinations failed...', e);
      dispatch(showToast({
        state: 'ERROR',
        title: 'Error',
        message: 'Issue retrieving admin stats. Please try again later',
        dismissible: true,
        dismissAfter: 1500,
      }));
      return { data: [] };
    }
  };
};

export const RECEIVE_EXPORTS_STATS = 'RECEIVE_EXPORTS_STATS';
export const receiveExportsStats = (payload) => ({ type: RECEIVE_EXPORTS_STATS, payload });

export const getStats = () => {
  return async (dispatch, getState) => {
    const { brand } = getState().app;
    const URL = `/brands/${brand.id}/audiences/stats/onboarded-by-destinations`;
    try {
      const stats = await dispatch(fetchData(URL));
      dispatch(receiveExportsStats(stats));
    } catch (e) {
      console.error('API Call to /audiences/stats/onboarded-by-destinations failed...', e);
      dispatch(showToast({
        state: 'ERROR',
        title: 'Error',
        message: 'Issue retrieving admin stats. Please try again later',
        dismissible: true,
        dismissAfter: 1500,
      }));
      dispatch(receiveExportsStats(defaultState.stats));
    }
  };
};

export default function reducer(state = defaultState, action = undefined) {
  switch (action.type) {
    case RECEIVE_EXPORTS_STATS:
      return {
        ...state,
        stats: action.payload,
      };
    case RECEIVE_ADMINISTRATION_INTEGRATIONS:
      return {
        ...state,
        integrations: action.payload.integrations,
        totalRecordsIntegrations: action.payload.totalRecordsIntegrations,
      };
    case UPDATE_INTEGRATIONS_PAGE:
      return {
        ...state,
        integrationCurrentPage: action.payload,
      };
    case INTEGRATION_UPDATE_SORT:
      return {
        ...state,
        sortBy: action.payload.sortBy,
        sortDirection: action.payload.sortDirection,
        integrationCurrentPage: 0,
      };
    case RESET_ROUTE_DATA:
      return {
        ...defaultState,
        currentTab: state.currentTab,
      };
    case TOGGLE_TAB:
      return {
        ...state,
        currentTab: action.payload,
      };
    default:
      return state;
  }
}
